// Possible types of a comment entities
export const COMMENT_ENTITY = {
  task: 'task',
  article: 'article',
};

// Report type constants
export const DEFAULT_REPORT = 'default';
export const DETAIL_REPORT = 'detail';
export const USER_REPORT = 'user';
